import React from 'react';
import { AlertCircle } from 'lucide-react';
import { SwitchToggle } from './SwitchToggle';
import { STOCK_OPTIONS, DISCONTINUED } from '../../../../lib/fabricLabels';

// Mutually exclusive stock switches (Stock available / Limited / No stock) + an independent "Discontinued" switch.
export const StockStatusToggles = ({ value, onChange, discontinued = false, onDiscontinuedChange, testIdPrefix, hint }) => (
  <div className="space-y-3">
    {STOCK_OPTIONS.map((o) => (
      <SwitchToggle
        key={o.value}
        label={<span className="flex items-center gap-2"><span className={`w-2 h-2 rounded-full ${o.dot}`} />{o.label}</span>}
        hint={hint ? hint(o) : `Show a ${o.label.toLowerCase()} dot online (text on hover)`}
        onColor={o.dot}
        checked={value === o.value}
        onToggle={() => onChange(value === o.value ? null : o.value)}
        testId={`${testIdPrefix}-stock-${o.value}`}
      />
    ))}
    {onDiscontinuedChange && (
      <div className="pt-3 border-t border-dashed border-neutral-200">
        <SwitchToggle
          label={<span className="flex items-center gap-2"><AlertCircle className="w-3 h-3 text-red-600" strokeWidth={2.5} />{DISCONTINUED.label}</span>}
          hint={hint ? hint(DISCONTINUED) : 'Red exclamation icon online — can be combined with any stock level'}
          onColor="bg-red-600"
          checked={!!discontinued}
          onToggle={() => onDiscontinuedChange(!discontinued)}
          testId={`${testIdPrefix}-stock-discontinued`}
        />
      </div>
    )}
  </div>
);

export default StockStatusToggles;
